// @ts-strict-ignore
import { PathParams, rest } from 'msw'
import {
  PaymentCaseDocumentsResponse,
  PaymentCaseEmailsResponse,
  PaymentCasesResponse,
  PaymentCaseType,
  PaymentsResponse,
} from 'types/payments'
import {
  TransferRequest,
  TransferResponse,
  TransferWalletsReponse,
} from 'types/unifiedPayouts/unifiedPayouts'
import paymentCaseDocumentsMockedResponse from '../../../__mocks__/CaseManagement/paymentCaseDocuments.json'
import paymentCaseEmailsMockedResponse from '../../../__mocks__/CaseManagement/paymentCaseEmails.json'
import paymentCasesMockedResponse from '../../../__mocks__/CaseManagement/paymentCases.json'
import mockCreatePayment from '../../../__mocks__/Payments/createPaymentResponse.json'
import paymentMethods from '../../../__mocks__/Payments/paymentMethods.json'
import mockPayments from '../../../__mocks__/Payments/paymentsResponse.json'
import mockTransferResponse from '../../../__mocks__/Payments/transferResponse.json'
import mockTransferWallets from '../../../__mocks__/Wallets/transferWallets.json'

const API_URL = process.env.API_URL

const getAllPayments = rest.get<PaymentsResponse>(
  `${API_URL}/api/v1/pay/ui`,
  async (req, res, ctx) => {
    return res(ctx.json(mockPayments))
  }
)

export const getPaymentSupportCases = rest.get<PaymentCasesResponse>(
  `${API_URL}/api/salesforce-facade/v1/case-management/cases`,
  async (req, res, ctx) => {
    const { searchParams } = req.url
    const status = searchParams?.get('status')
    const mockResponse = { ...paymentCasesMockedResponse }

    if (status === PaymentCaseType.NEW) {
      const newCases = mockResponse?.cases?.filter(caseItem => caseItem?.status === status)
      return res(ctx.status(200), ctx.json({ cases: newCases, count: newCases?.length }))
    } else {
      return res(ctx.status(200), ctx.json(paymentCasesMockedResponse))
    }
  }
)

export const getPaymentSupportCasesEmpty = rest.get<PaymentCasesResponse>(
  `${API_URL}/api/salesforce-facade/v1/case-management/cases`,
  async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json([]))
  }
)

export const getPaymentSupportCasesException = rest.get(
  `${API_URL}/api/salesforce-facade/v1/case-management/cases`,
  async (req, res, ctx) => res(ctx.status(400))
)

const getPaymentCaseDocuments = rest.get<PaymentCaseDocumentsResponse>(
  `${API_URL}/api/salesforce-facade/v1/case-management/documents`,
  async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(paymentCaseDocumentsMockedResponse))
  }
)

export const getPaymentCaseDocumentsEmpty = rest.get<PaymentCaseDocumentsResponse>(
  `${API_URL}/api/salesforce-facade/v1/case-management/documents`,
  async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json([]))
  }
)

export const getPaymentCaseDocumentsException = rest.get(
  `${API_URL}/api/salesforce-facade/v1/case-management/documents`,
  async (req, res, ctx) => res(ctx.status(400))
)

const getPaymentCaseEmails = rest.get<PaymentCaseEmailsResponse>(
  `${API_URL}/api/salesforce-facade/v1/case-management/emails`,
  async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(paymentCaseEmailsMockedResponse))
  }
)

export const getPaymentCaseEmailsEmpty = rest.get<PaymentCaseEmailsResponse>(
  `${API_URL}/api/salesforce-facade/v1/case-management/emails`,
  async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json([]))
  }
)

export const getPaymentCaseEmailsException = rest.get(
  `${API_URL}/api/salesforce-facade/v1/case-management/emails`,
  async (req, res, ctx) => res(ctx.status(400))
)

const postCreatePaymentHandler = rest.post(
  `${API_URL}/api/v1/pay/summary`,
  async (req, res, ctx) => {
    return res(ctx.json(mockCreatePayment))
  }
)

export const postCreatePaymentError = rest.post(
  `${API_URL}/api/v1/pay/summary`,
  async (req, res, ctx) => {
    return res(ctx.status(500), ctx.json({ message: 'Internal server error' }))
  }
)

export const postCreatePaymentFieldErrors = rest.post(
  `${API_URL}/api/v1/pay/summary`,
  async (req, res, ctx) => {
    return res(
      ctx.status(400),
      ctx.json({
        errorList: [
          { parameter: 'amount', message: 'Amount must be greater than 0' },
          { parameter: 'reference', message: 'Reference already exists' },
        ],
      })
    )
  }
)

const getPaymentMethods = rest.get(`${API_URL}/api/payment-method`, async (req, res, ctx) => {
  return res(ctx.json(paymentMethods))
})

export const getPaymentMethodsEmpty = rest.get(
  `${API_URL}/api/payment-method`,
  async (req, res, ctx) => {
    return res(ctx.json([]))
  }
)

const postPaymentTransfer = rest.post<TransferRequest, PathParams, TransferResponse>(
  `${API_URL}/payment/v2/transfers`,
  async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockTransferResponse))
  }
)

export const postPaymentTransferBadRequestError = rest.post(
  `${API_URL}/payment/v2/transfers`,
  async (req, res, ctx) => {
    return res(
      ctx.status(400),
      ctx.json({
        errorList: [{ parameter: 'amount', message: 'Insufficient balance' }],
      })
    )
  }
)

export const postPaymentTransferGenericError = rest.post(
  `${API_URL}/payment/v2/transfers`,
  async (req, res, ctx) => {
    return res(ctx.status(500), ctx.json({ message: 'Internal server error' }))
  }
)

const getPayoutsTransferWallets = rest.get<TransferWalletsReponse[]>(
  `${API_URL}/payment/v1/transfers/*/beneficiaries`,
  async (req, res, ctx) => {
    const { searchParams } = req.url
    const currencyCode = searchParams.get('currencyCode')
    const walletType = searchParams.get('walletType')

    let filteredWallets = [...mockTransferWallets]

    if (currencyCode) {
      filteredWallets = filteredWallets.filter(wallet => wallet.currencyCode === currencyCode)
    }

    if (walletType) {
      filteredWallets = filteredWallets.filter(wallet => wallet.walletType === walletType)
    }

    return res(ctx.status(200), ctx.json(filteredWallets))
  }
)

export const getPayoutsTransferWalletsEmpty = rest.get(
  `${API_URL}/payment/v1/transfers/*/beneficiaries`,
  async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json([]))
  }
)

export const getPayoutsTransferWalletsError = rest.get(
  `${API_URL}/payment/v1/transfers/*/beneficiaries`,
  async (req, res, ctx) => {
    return res(
      ctx.status(400),
      ctx.json({
        errorList: [{ parameter: 'walletId', message: 'Invalid wallet ID' }],
      })
    )
  }
)

export default [
  getAllPayments,
  postCreatePaymentHandler,
  getPaymentMethods,
  getPaymentSupportCases,
  getPaymentCaseDocuments,
  getPaymentCaseEmails,
  getPaymentMethodsEmpty,
  postPaymentTransfer,
  getPayoutsTransferWallets,
]
